export const LudumEventBus = new Vue();

// EVENTS and SESSION
export const SESSION_ATTENDANCE_UPDATE_SQUADS = 'attendance:update-selected-squads';

// PRIVATE NOTES
export const NOTES_REMOVE_FILE = 'notes:remove-file';

export const REFRESH_AGENDA = 'refresh-agenda';
export const REFRESH_SESSION = 'refresh-session';
export const REFRESH_SQUADS = 'refresh-squads';
export const REFRESH_INTEGRATIONS = 'refresh-integrations';

export const CLOSE_SEARCH = 'close-search';

export const RESET_SESSION_FORM = 'reset-session-form';

export const WALL_POSTS_ADD = 'wall-posts-add';
export const WALL_POSTS_DELETE = 'wall-posts-delete';

export const CLOSE_MENU_DROPDOWN = 'close-menu-dropdown';
export const TOGGLE_NAVIGATION = 'toggle-navigation';
export const OPEN_NAVIGATION = 'open-navigation';
export const CLOSE_NAVIGATION = 'close-navigation';
export const OPEN_ADMIN_NAVIGATION = 'open-admin-navigation';
export const CLOSE_ADMIN_NAVIGATION = 'close-admin-navigation';

export const TOGGLE_FILTER = 'toggles-filter';

export const CALENDAR_OPEN_WEEKLY_SUMMARY = 'calendar:open-weekly-summary';

export const AUTO_IMPORT_RELOAD_FILES = 'auto-import:reload-files';

export const CLUB_CHANGE_IMAGE = 'club:change-image';

export const CLUB_MEMBERS_LOAD = 'club-members:load';

export const FILE_UPLOADED = 'file-uploaded';

export const EQUIPMENT_CATEGORY_DELETED = 'equipment:category-deleted';
export const EQUIPMENT_EQUIPMENT_DELETED = 'equipment:equipment-deleted';
export const EQUIPMENT_EQUIPMENT_ASSIGNED = 'equipment:equipment-assigned';

export const CHALLENGE_DELETE_TEAM = 'challenge:delete-team';

export default LudumEventBus;
